import { Location } from "@remix-run/router";
import { matchPath } from "react-router";

export const checkForActive = (location: Location, ...to: string[]): boolean => {
  const anyMatch: boolean[] = to.map(
    (t) =>
      !!matchPath(
        {
          path: t,
          caseSensitive: false,
        },
        location.pathname,
      ),
  );
  return !!to && anyMatch.includes(true);
};
